/**
 * tenantSlugRef
 * --------------------------------------------------------------
 * Module-level singleton for the active município slug.
 *
 * Why?
 * - Axios request interceptor (services/api.js) runs OUTSIDE React, so it
 *   cannot use `useParams()`. Previously it parsed `window.location.pathname`
 *   manually with a static blocklist of system routes — fragile and required
 *   updating whenever a new top-level route was added (e.g. /m/, /mg/).
 * - This ref is updated by `<TenantSlugSync />` mounted inside React Router
 *   so the blocklist is no longer the source of truth — Router is.
 *
 * The ref returns null when the user is NOT inside a tenant route, so the
 * interceptor falls back to admin-selected tenant from localStorage.
 */
let _slug = null;

export function setTenantSlug(slug) {
  _slug = slug || null;
}

export function getTenantSlug() {
  return _slug;
}
